import userBgMobile from '@/assets/images/user-bg-mobile.webp'
import userBg from '@/assets/images/user_new_bg.png'
import brandDirectorBg from '@/assets/images/brand_director_bg.png'
import officialBg from '@/assets/images/officialBg.png'
import officialBgMobile from '@/assets/images/officialBg-mobile.webp'

export const PermissionKey = {
  D3: '/aigc/generate/model3d'
}

export const SHOP_BASE_URL = window.__SHOP_BASE_URL__ || ''

// 判断url是否是图片
export const imageReg = new RegExp(/\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i)

// 判断url是否是视频
export const videoReg = new RegExp(/\.(mp4|mov|avi|mkv|flv|wmv|webm|mpeg|mpg|3gp)$/i)

export const Language = {
  en: 'US,en',
  zh: 'CN,zh-Hans'
}

export const JobKey = {
  img2img: Symbol('img2img-modal'), //图生图弹窗
  inpainting: Symbol('inpainting'), //局部重绘
  generatorImage: Symbol('generator-image'), //文生图，图生图
  generatorHD: Symbol('generator-hd'), //高清
  generatorImg2Img: Symbol('generator-img2img'), //以图生图
  generatorChallenge: Symbol('generator-challenge'), //挑战
  generator3d: Symbol('generator-3d') //以图生图
}

export const JobKeyMap = {
  img2img: 'img2img-modal', //图生图弹窗
  inpainting: 'inpainting', //局部重绘
  generatorImage: 'generator-image', //文生图，图生图
  generatorHD: 'generator-hd', //高清
  generatorImg2Img: 'generator-img2img', //以图生图
  generatorChallenge: 'generator-challenge', //挑战
  generator3d: 'generator-3d', //以图生图
  generatorVideo: 'generator-video' //以图生视频
}

export const ErrorRetry = {
  maxCount: 5,
  interval: 3000
}

export const GenerateTypeNames = {
  TextToImg: '好物设计-文生图',
  ImgToImg: '好物设计-图生图',
  Inpainting: '局部修改',
  HD: '画质超清',
  ImageTo3D: '图生3D',
  ImgToVideo: '图生视频',
  Action: {
    SendImage: '指令编辑'
  }
}

/** 账号等级 */
export const AccountLevel = {
  normal: '', // 普通
  official: 'official', // 官方
  officialQualityCreator: 'officialQualityCreator', // 好物设计师
  brandDirector: 'brandDirector' // 甄选艺术家
}

/** 账号等级LOGO列表 */
export const AccountLevelImage = {
  [AccountLevel.official]: 'https://static.zaohaowu.com/static/artist/official.svg',
  [AccountLevel.officialQualityCreator]: 'https://static.zaohaowu.com/static/artist/mask-big.png',
  [AccountLevel.brandDirector]: 'https://static.zaohaowu.com/static/artist/start.png'
}

/** 账号等级背景图列表 */
export const AccountLevelBackgroundImage = {
  [AccountLevel.normal]: userBg,
  [AccountLevel.official]: officialBg,
  [AccountLevel.officialQualityCreator]: userBg,
  [AccountLevel.brandDirector]: brandDirectorBg
}

/** H5账号等级背景图列表 */
export const AccountLevelBackgroundImageMobile = {
  [AccountLevel.normal]: userBgMobile,
  [AccountLevel.official]: officialBgMobile,
  [AccountLevel.officialQualityCreator]: userBgMobile
}

// LocalStorageKey
export const LocalStorageKey = {
  homeCreatNew: 'homeCreatNew'
}

export const DesignText = {
  ZaoWu: '造物',
  Generate: '生成'
}

// 此枚举是后端接口返回的值
export enum GenerateType {
  All = -1,
  TextToImg = 0,
  ImgToImg = 1,
  ImgToVideo = 6,
  ImgOrTextToImg = 7
}
